



















import Vue from 'vue'
import ProjectForm from '@/components/project/ProjectForm.vue'
import moment from 'moment'
import { Project } from '@/model/Project'
import { User } from '@/model/User'
import ProjectService from '@/service/ProjectService'

export default Vue.extend({
  name: 'ProjectEdit',
  components: {
    ProjectForm,
  },
  props: {
    slug: {
      type: String,
    },
  },
  mounted() {
    this.$api
      .get('/projects/slug/' + this.slug)
      .then((response) => {
        if (
          ((response.data as Project).author as User).nickname !==
          this.$store.state.authentication.user.nickname
        ) {
          this.$router.push('/404')
          return
        }
        this.project = response.data
        if (!this.project) {
          return
        }
        this.project.startAt = moment(this.project.startAt).format('YYYY-MM-DD')
      })
      .catch(() => this.$router.push('/404'))
  },
  data: () => ({
    publishLoading: false,
    publishAndJoinLoading: false,
    project: null as Project | null,
  }),
  methods: {
    publishProject: function () {
      if (!this.project) {
        return
      }

      this.publishLoading = true

      this.$api
        .put(this.project['@id'], ProjectService.prepareDataToApi(this.project))
        .then((response) => {
          this.$store.dispatch('alert/success', 'Project has been updated!')
          this.$router.push('/project/' + (response.data as Project).slug)
        })
        .catch(() =>
          this.$store.dispatch(
            'alert/error',
            'Problems with project publishing.'
          )
        )
        .finally(() => (this.publishLoading = false))
    },
    publishAndJoinClicked: function() {
      if (!this.project) {
        return
      }

      this.publishAndJoinLoading = true

      this.$api
        .put(this.project['@id'], ProjectService.prepareDataToApi(this.project))
        .then((response) => {
          this.$store.dispatch('alert/success', 'Project has been updated!')
          this.$router.push('/contests/open')
        })
        .catch(() =>
          this.$store.dispatch(
            'alert/error',
            'Problems with project publishing.'
          )
        )
        .finally(() => (this.publishAndJoinLoading = false))
    },
  },
})
